import { ActionReducer, ActionReducerMap, MetaReducer } from '@ngrx/store';
import { AppState as State } from './state';

import * as fromCommon from './common/common.reducer';
import * as fromAccount from './account/account.reducer';
import * as fromRoot from './root/root.reducer';
import * as fromCategories from './categories/categories.reducer';

import { environment } from 'src/environments/environment';

export const reducers: ActionReducerMap<State> = {
    common: fromCommon.reducer,
    account: fromAccount.reducer,
    root: fromRoot.reducer,
    categories: fromCategories.reducer
};

export function logger(reducer: ActionReducer<State>): ActionReducer<any, any> {
    return (state: State, action: any): State => {
        return reducer(state, action);
    };
}

export const metaReducers: MetaReducer<State>[] = !environment.production
    ? [logger]
    : [];

